export function rejectNull<T>(input: T): NonNullable<T> {
  if (input === null || input === undefined) {
    throw new TypeError("Expected non-null value");
  }
  return input as NonNullable<T>;
}
